import { EXTERNAL_URLS } from "@constants/api.urls";
import { FOOTER_URL } from "@constants/api.urls";
import { USER_INFO } from "@constants/global.constants";

import { InstagramIcon, LinkedInIcon, YoutubeIcon } from "@components/SVGs";

// Social media links with their respective icons
export const SOCIAL_MEDIA_LINKS = [
  { href: EXTERNAL_URLS.linkedinURL, Icon: LinkedInIcon, id: "linkedin-icon-btn" },
  { href: EXTERNAL_URLS.instagramURl, Icon: InstagramIcon, id: "instagram-icon-btn" },
  { href: EXTERNAL_URLS.youtubeURL, Icon: YoutubeIcon, id: "youtube-icon-btn" },
];

export const FOOTER_LINKS = (t, language) => {
  const footerData = FOOTER_URL[language] || FOOTER_URL[USER_INFO.cultureName];
  return [
    { href: footerData.dupontUrl, text: t("dupontCom") },
    { href: footerData.privacyUrl, text: t("privacy") },
    { href: footerData.termsConditions, text: t("legalNoticeUsageTerms") },
    { href: footerData.a11yUrl, text: t("ally") },
  ];
};
